import { Download, Loader2 } from "lucide-react";
import { cn } from "@/utils/cn";
import ExternalLink from "@/components/buttons/ExternalLink";
import { baseClasses, colorClasses } from "@/components/buttons/buttonStyles";

interface ContractPdfLinkProps {
  documentUrl: string | null;
  pdfGenerating: boolean;
  variant?: "primary" | "secondary";
  label?: string;
  icon?: boolean;
  className?: string;
}

const ContractPdfLink: React.FC<ContractPdfLinkProps> = ({
  documentUrl,
  pdfGenerating,
  variant = "secondary",
  label = "Download",
  icon = false,
  className,
}) => {
  if (documentUrl) {
    return (
      <ExternalLink
        href={documentUrl}
        target="_blank"
        rel="noopener noreferrer"
        type={variant}
        className={cn("gap-2", className)}
      >
        {icon && <Download size={16} />}
        {label}
      </ExternalLink>
    );
  }

  if (pdfGenerating) {
    return (
      <span
        className={cn(
          baseClasses,
          colorClasses.peach[variant],
          "cursor-default gap-2 opacity-50",
          className,
        )}
      >
        <Loader2 className="animate-spin" size={16} />
        Generating...
      </span>
    );
  }

  return null;
};

export default ContractPdfLink;
